import { Outlet } from 'react-router-dom';
import React, { useState } from 'react';
import { AuthGuard } from './AuthGuard';

export const ProtectedLayout = React.memo(() => {
  const [isReady, setIsReady] = useState(false);

  return <AuthGuard onReady={() => setIsReady(true)}>{isReady && <Outlet />}</AuthGuard>;
});
